// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d2e27689","134":"8aac4bcc","355":"f7fb3f72","467":"28c668c0","969":"f5d5e6ac"}[chunkId] + ".chunk.js";
};